import React from 'react';
import styled from 'styled-components';
import Tooltip from '../../Tooltip';

const InputTextAreaContainer = styled.div`
  textarea {
    width: calc(100% - 30px) !important;
    padding: 15px !important;
    height: ${(props) => (props.height ? props.height : '150px')};
    border: 1px solid #e8eaeb;
    border-radius: 2px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    outline: none;
  }

  textarea::placeholder {
    opacity: 0.3;
    font-family: ${(props) => props.theme.fonts.sfcompact_italic};
  }

  .label {
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.oswald};
    text-transform: uppercase;
    margin-bottom: 7px;
  }

  .labelContainer {
    display: flex;
    flex-direction: row;
  }

  .labelContainer > div {
    margin-left: 4px;
  }
`;

const InputTextArea = (props) => (
  <InputTextAreaContainer height={props.height}>
    {props.label && (
      <div className="labelContainer">
        <p className="label">{props.label}</p>
        {props.tooltip && (
          <div className="tooltipContainer">
            <Tooltip {...props.tooltip} />
          </div>
        )}
      </div>
    )}
    <textarea
      disabled={props.disable}
      rows={props.rows}
      cols={props.cols}
      placeholder={props.placeholder}
      onChange={(e) => props.onChange(e.target.value)}
      value={props.value}
    />
  </InputTextAreaContainer>
);

export default InputTextArea;
